
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.096 19.681l-5.147-5.146a7.2 7.2 0 10-1.414 1.414l5.146 5.147 1.415-1.415zM15.4 10.2a5.2 5.2 0 11-10.4 0 5.2 5.2 0 0110.4 0z","fill":"#517BA6"}})])
          )
        }
      }
    